import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/common/cupAction.svg?url_encode")